import type { TOC } from '@ember/component/template-only';
import type ScreenerResult from 'garaje/models/screener-result';
import type { IdScanningReport } from 'garaje/models/screener-result';
import type { GuestWithVisitApproval } from 'garaje/models/visit-approval';

interface IdScanningSignature {
  Args: {
    result: ScreenerResult<IdScanningReport>;
    model: GuestWithVisitApproval;
  };
  Blocks: {
    default: [];
  };
}

export default <template>
  {{#if @model.visitApproval.idScanningPendingResult}}
    <li class="text-sm mt-4" data-test-id-scanning-pending>
      <img src="/assets/images/progress-small-gray.svg" alt="" role="presentation" />&nbsp;
      <span class="whitespace-nowrap">
        Visitor’s ID is processing.
      </span>
    </li>
  {{else}}
    {{#if @model.visitApproval.idScanningReviewResult}}
      <li class="text-sm mt-4">{{@result.idScanningFailureMessage}}</li>
    {{/if}}
  {{/if}}
  {{yield}}
</template> satisfies TOC<IdScanningSignature>;
